<template>
  <div class="date-column" @click="openPicker">
    <div class="date-card">
      <div class="date-big">{{ dateLabel }}</div>
      <div class="date-weekday" :class="{ weekend: isWeekend }">
        {{ weekdayLabel }}
      </div>
    </div>
    <div class="date-current-time">{{ currentTimeLabel }}</div>


    <!-- 3) transparent el-date-picker, растянутый на весь блок, чтобы ловить клик -->
    <el-date-picker
      ref="picker"
      v-model="internalDate"
      type="date"
      format="DD.MM.YYYY"
      value-format="YYYY-MM-DD"
      @change="onDateChange"
      class="date-picker-overlay"
      style="position: absolute!important;
  left: 0; top: 0;
  width: 100%; height: 100%;
  opacity: 0;
  z-index: 2;
  pointer-events: none;"
    />
  </div>
</template>

<script>
export default {
  name: 'DateColumn',
  props: {
    // В родителе (Calendar.vue) делаем <DateColumn v-model="selectedDate" />.
    // Сюда придёт строка типа "2025-05-31".
    modelValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // Если из props ничего не пришло, ставим сегодня (ISO)
      internalDate: this.modelValue || new Date().toISOString().slice(0, 10),
      nowTs: Date.now(),
      timer: null
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.nowTs = Date.now()
    }, 1000 * 30)
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  watch: {
    // Если родитель вручную поменял modelValue, синхронизируем internalDate.
    modelValue(newVal) {
      if (newVal && newVal !== this.internalDate) {
        this.internalDate = newVal
      }
    }
  },
  computed: {
    weekdayLabel() {
      if (!this.internalDate) return ''
      const d = new Date(this.internalDate)
      if (isNaN(d.getTime())) return ''
      const weekdays = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
      return weekdays[d.getDay()]
    },
    isWeekend() {
      if (!this.internalDate) return false
      const d = new Date(this.internalDate)
      if (isNaN(d.getTime())) return false
      return d.getDay() === 0 || d.getDay() === 6
    },
    dateLabel() {
      if (!this.internalDate) return ''
      const d = new Date(this.internalDate)
      if (isNaN(d.getTime())) return ''
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}.${month}.${year}`
    },
    currentTimeLabel() {
      const now = new Date(this.nowTs)
      const hh = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      return `${hh}:${mm}`
    }
  },
  methods: {
    onDateChange(newDate) {
      // newDate уже будет точно в формате "YYYY-MM-DD"
      if (!newDate) return
      this.internalDate = newDate
      this.$emit('update:modelValue', newDate)
    },
    openPicker() {
      const picker = this.$refs.picker
      if (picker && typeof picker.handleOpen === 'function') {
        picker.handleOpen()
      }
    }
  }
}
</script>

<style scoped>
.date-column {
  height: 106px;
  width: 150px;
  background: transparent;
  text-align: center;
  cursor: pointer;
  user-select: none;
  padding: 0 12px 6px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-card {
  border-radius: 10px;
  background: var(--appointment-surface-overlay-bg), var(--appointment-surface-base);
  border: 1px solid var(--cal-border);
  padding: 8px 6px 6px;
  box-shadow: inset 0 0 0 1px rgba(122, 164, 233, 0.16);
}

.date-big {
  font-size: 17px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1px;
  color: var(--cal-text-inverse);
}

/* Скрываем сам input календаря, но он остаётся кликабельным */
.date-picker-overlay {
  position: absolute!important;
  left: 0; top: 0;
  width: 100%; height: 100%;
  opacity: 0;
  z-index: 2;
  pointer-events: none; /* чтобы не мешал клику по блоку */
}
.date-weekday {
  font-size: 8px;
  color: var(--cal-text-primary);
  margin-bottom: 0;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.date-current-time {
  margin: 0;
  width: 100%;
  height: 40px;
  border-radius: 10px;
  border: 1px solid var(--cal-border);
  background: var(--appointment-surface-overlay-bg), var(--appointment-surface-base);
  color: var(--cal-text-inverse);
  font-size: 17px;
  line-height: 40px;
  font-weight: 700;
  overflow: hidden;
  letter-spacing: 0.5px;
  box-shadow: inset 0 0 0 1px rgba(122, 164, 233, 0.12);
}

.date-weekday.weekend {
  color: var(--ui-color-danger);
  font-weight: 700;
}
</style>
